import React, { useEffect, useState } from 'react'
import { PressReleaseLight } from '@finance-lab/utils/types'
import { PressReleaseApi } from '../../../../api/PressReleasesApi'
import Card from '@mui/material/Card'
import List from '@mui/material/List'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import { formatDateYYYYMMDD } from '../../../../packages/utils/numberFormatters'
import ListItemButton from '@mui/material/ListItemButton'
import { Link } from 'react-router-dom'
import { getNewsLink } from '../../../../utils/get-news-link'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import { PressReleaseAvatar } from '../../../../components/entities/PressReleaseAvatar'
import { PressReleaseRelatedTransactions } from '../../../../components/entities/PressReleaseRelatedTransactions'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import useAuth from '../../../../hooks/useAuth'

const pressReleaseApi = new PressReleaseApi()

export const CompanyPressReleases = ({ companyId, currentPrId }: { companyId: string; currentPrId?: string }) => {
    const [pressReleases, setPressReleases] = useState<PressReleaseLight[] | null>(null)
    const { user } = useAuth()

    useEffect(() => {
        const fetchData = async () => {
            const result = await pressReleaseApi.allPressReleases({ page: 0, pageSize: 10 }, { companyId })

            setPressReleases(result.data)
        }

        void fetchData()
    }, [companyId])

    return (
        <Card>
            <CardContent sx={{ padding: 0 }}>
                <Typography variant={'h4'} sx={{ margin: 4, marginBottom: 2 }}>
                    Pressmeddelanden
                </Typography>

                <List>
                    {pressReleases?.map((pr) => (
                        <ListItemButton
                            key={pr.id}
                            alignItems='flex-start'
                            selected={pr.id === currentPrId}
                            LinkComponent={Link}
                            to={getNewsLink(companyId, pr.id)}
                        >
                            <ListItemAvatar>
                                <PressReleaseAvatar pressRelease={pr} />
                            </ListItemAvatar>
                            <ListItemText
                                primary={pr.title}
                                slotProps={{
                                    primary: {
                                        sx: {
                                            display: '-webkit-box',
                                            WebkitLineClamp: '2',
                                            overflow: 'hidden',
                                            WebkitBoxOrient: 'vertical',
                                        },
                                        title: pr.title,
                                        variant: 'body1',
                                    },
                                }}
                                secondary={
                                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                        <div>{formatDateYYYYMMDD(pr.publishedAt)}</div>
                                        <PressReleaseRelatedTransactions relatedTransactions={pr.relatedTransactions} />
                                    </Box>
                                }
                            />
                        </ListItemButton>
                    ))}
                </List>
                {user?.groups?.includes('superadmin') ? (
                    <Box sx={{ textAlign: 'center' }}>
                        <Button component={Link} to={`/press-releases?companyId=${companyId}`} variant='outlined'>
                            Visa alla PM
                        </Button>
                    </Box>
                ) : null}
            </CardContent>
        </Card>
    )
}
